import axios from 'axios';

// Backend (Django) host. Env-driven at build time via REACT_APP_BACKEND_HOST (see build.env);
// falls back to the deployed host. Local dev: set REACT_APP_BACKEND_HOST=http://localhost:8000.
const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST || 'https://swans.risktrackerapp.com';

// SWANS metrics API Gateway prefix. The browser calls this gateway directly for several metric
// screens. Normalized to exactly one trailing slash so `getMetricsApiPrefix() + 'route'` is stable.
// The fallback must match build.env. It used to name the OLDER gateway (chapfk2u97) even though
// the read APIs moved to 9wsjdgvng6, so a build that didn't receive build.env silently aimed
// every metrics call at a gateway that doesn't serve these routes. chapfk2u97 is still live for
// OTHER endpoints (analysis-app /airport-data, isarm /notams/get-airport-status, swans
// views.py), so it is not dead — just not the metrics gateway.
const METRICS_API_PREFIX =
    (process.env.REACT_APP_METRICS_API_PREFIX ||
        'https://9wsjdgvng6.execute-api.us-east-2.amazonaws.com/test').replace(/\/+$/, '') + '/';

// API key for the metrics gateway (build-time; see build.env). Public by nature — it's inlined
// into the browser bundle, so it's identification/throttling, not a hard secret.
const METRICS_API_KEY = process.env.REACT_APP_METRICS_API_KEY || '';

// Attach x-api-key to every request that targets the metrics gateway. Registered once here (this
// module is imported by every metric screen) via a global axios interceptor, so no per-call-site
// change is needed. Only matches the gateway host, so same-origin /api (Django) calls are untouched.
const METRICS_BASE = METRICS_API_PREFIX.replace(/\/+$/, '');
if (METRICS_API_KEY) {
    axios.interceptors.request.use((config) => {
        if ((config.url || '').indexOf(METRICS_BASE) === 0) {
            config.headers = config.headers || {};
            config.headers['x-api-key'] = METRICS_API_KEY;
        }
        return config;
    });
}

// fetch() equivalent of the axios interceptor above. Browser fetch() bypasses axios entirely,
// so gateway calls made with raw fetch never pick up the interceptor's x-api-key and get 403'd
// (every SwansReadApi route sets ApiKeyRequired). Use this instead of fetch() for gateway URLs.
export function metricsFetch(url, options = {}) {
    const headers = { ...(options.headers || {}) };
    if (METRICS_API_KEY && (url || '').indexOf(METRICS_BASE) === 0) {
        headers['x-api-key'] = METRICS_API_KEY;
    }
    return fetch(url, { ...options, headers });
}

export function getBackendHost(){
    return BACKEND_HOST;
}

export function getMetricsApiPrefix(){
    return METRICS_API_PREFIX;
}

export function getMetricsApiKey(){
    return METRICS_API_KEY;
}
